export default [
  {
    path: '/metaplanet_LtbDeposit',
    name: 'LtbDepositView',
    component: () =>
      import(
        /* webpackChunkName: "portal-log" */ '@/views/PortalLog/LtbDepositView.vue'
      ),
    meta: { title: 'LTB Deposit', group: 'portal-log' },
  },
  {
    path: '/metaplanet_LtbSwap',
    name: 'LtbSwapView',
    component: () =>
      import(
        /* webpackChunkName: "portal-log" */ '@/views/PortalLog/LtbSwapView.vue'
      ),
    meta: { title: 'LTB Swap', group: 'portal-log' },
  },
  {
    path: '/metaplanet_LtbTransferMetaq',
    name: 'LtbTransferMetaqView',
    component: () =>
      import(
        /* webpackChunkName: "portal-log" */ '@/views/PortalLog/LtbTransferMetaqView.vue'
      ),
    meta: { title: 'LTB Transfer Metaq', group: 'portal-log' },
  },
  {
    path: '/metaplanet_LtbWithdraw',
    name: 'LtbWithdrawView',
    component: () =>
      import(
        /* webpackChunkName: "portal-log" */ '@/views/PortalLog/LtbWithdrawView.vue'
      ),
    meta: { title: 'LTB Withdraw', group: 'portal-log' },
  },
  {
    path: '/metaplanet_LtbMetaq',
    name: 'LtbMetaqView',
    component: () =>
      import(
        /* webpackChunkName: "portal-log" */ '@/views/PortalLog/LtbMetaqView.vue'
      ),
    meta: { title: 'LTB Metaq', group: 'portal-log' },
  },
  {
    path: '/metaplanet_LtbNftStaking',
    name: 'LtbNftStakingView',
    component: () =>
      import(
        /* webpackChunkName: "portal-log" */ '@/views/PortalLog/LtbNftStakingView.vue'
      ),
    meta: { title: 'LTB NFT Staking', group: 'portal-log' },
  },
  {
    path: '/metaplanet_LtbTokens',
    name: 'LtbTokensView',
    component: () =>
      import(
        /* webpackChunkName: "portal-log" */ '@/views/PortalLog/LtbTokensView.vue'
      ),
    meta: { title: 'LTB Tokens', group: 'portal-log' },
  },
  {
    path: '/metaplanet_LtbTransferNft',
    name: 'LtbTransferNftView',
    component: () =>
      import(
        /* webpackChunkName: "portal-log" */ '@/views/PortalLog/LtbTransferNftView.vue'
      ),
    meta: { title: 'LTB Transfer NFT', group: 'portal-log' },
  },
]
